import { createStore } from 'vuex'
import auth from '@js/store/modules/auth.js';
import announcements from '@js/store/modules/announcements.js';
import candidate from '@js/store/modules/candidate.js';
import user from '@js/store/modules/user.js';
import fee from '@js/store/modules/fee.js';
import resources from '@js/store/modules/resources.js';
import booking from '@js/store/modules/booking.js';
import companies from '@js/store/modules/companies.js';
import services from '@js/store/modules/services.js';
import notifications from '@js/store/modules/notifications.js';
import invoices from '@js/store/modules/invoices.js';
import todo from '@js/store/modules/todo.js';
import zone from '@js/store/modules/zone.js';

const store = createStore({
	modules: {
		announcements,
		auth: auth,
		candidate,
		user,
		fee,
		resources,
		booking,
		companies,
		services,
		notifications,
		invoices,
		todo,
		zone
	}
})

export default store;
